import BaseService from '../BaseService'

export default class FormConfigService extends BaseService {
  constructor() {
    super('formconfig')
  }

}
